module.exports = __webpack_public_path__ + "static/media/joined-on.2c671ee0.svg";